import { render, staticRenderFns } from "./visLeftPie.vue?vue&type=template&id=1b467d88"
import script from "./visLeftPie.vue?vue&type=script&lang=js"
export * from "./visLeftPie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports